"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useId = useId;

var _react = require("react");

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var counter = 0;

function useId() {
  return (0, _react.useMemo)(function () {
    counter++;
    return "clay-id-".concat(counter);
  }, []);
}